import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';

class DynamicText extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};

	}

	componentDidMount() {
	}

    render() {

        let experience = '';
        switch(parseInt(this.props.experience, 10)) {
            case 1:
                experience = this.props.t('DynamicText_Beginner');
                break;
            case 2:
                experience = this.props.t('DynamicText_LittleExperience');
                break;
            case 3:
                experience = this.props.t('DynamicText_Experienced');
                break;
            case 4:
                experience = this.props.t('DynamicText_VeryExperienced');
                break;
            case 5:
                experience = this.props.t('DynamicText_Expert');
                break;
            default:
                experience = '';
        }

        var suspension = '';
        switch (parseInt(this.props.suspension, 10)) {
            case 1:
                suspension = 'rigid';
                break;
            case 2:
                suspension = 'hardtail';
                break;
            case 3:
                suspension = 'full suspension';
                break;
            default:
                suspension = '';
        }

        var bikeType = '';
        switch (this.props.bikeType) {
            case 'XC':
                bikeType = 'cross country mountainbike';
                break;
            case 'Trail':
                bikeType = 'trail bike';
                break;
            case 'Fatbike':
                bikeType = 'fatbike';
                break;
            case 'Enduro':
                bikeType = 'enduro mountainbike';
                break;
            case 'Downhill':
                bikeType = 'downhill mountainbike';
                break;
            default:
                bikeType = (this.props.bikeType || '').toLowerCase();
        }

        var speed = '';

        switch (parseInt(this.props.speed, 10)) {
            case 1:
                speed = this.props.t('DynamicText_Speed');
                break;
            case 2:
                speed = this.props.t('DynamicText_Speed_Comfort');
                break;
            case 3:
                speed = this.props.t('DynamicText_Comfort');
                break;
            default:
                speed = '';
        }

        return (
            <div className="text-center well">
                <h3>{this.props.title}</h3>
                <p>
                    {this.props.t('DynamicText_YouHaveSaid')} <strong>{experience}</strong> {this.props.t('DynamicText_ToBeAMTBer')}. {this.props.t('DynamicText_YouAreSearching')} <strong>{suspension} {bikeType}</strong>. {this.props.t('DynamicText_ForYouItIs')} <strong>{speed}</strong> {this.props.t('DynamicText_Important')}. {this.props.t('DynamicText_WeAdviceYou')} {this.props.t('DynamicText_Maximum')} <strong>{this.props.advicePrice}</strong> {this.props.t('DynamicText_Euro')} {this.props.t('DynamicText_EndText')}
                </p>
            </div>
        );

    }

}

export default withTranslation('price')(DynamicText);
